import { useAuthContext } from "../auth/AuthContext";
import LoadingScreen from "../components/LoadingScreen";
import { useMinDuration } from "../hooks/useMinDuration";

function MicrosoftLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 21 21" fill="none">
      <rect x="1"  y="1"  width="9" height="9" fill="#f25022"/>
      <rect x="11" y="1"  width="9" height="9" fill="#7fba00"/>
      <rect x="1"  y="11" width="9" height="9" fill="#00a4ef"/>
      <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
    </svg>
  );
}

export default function LoginPage() {
  const { loginMicrosoft, error, isAuthenticating, clearError } = useAuthContext();
  const isAuthenticatingDelayed = useMinDuration(isAuthenticating);

  if (isAuthenticatingDelayed) return <LoadingScreen message="Connexion…"/>;

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="band"/>
        <div style={{ padding:"36px 40px 40px" }}>

          {/* Logo */}
          <div style={{ textAlign:"center", marginBottom:32 }}>
            <img src="/logo.png" alt="logo" style={{ height:48, objectFit:"contain", margin:"0 auto 14px", display:"block" }}/>
            <p style={{ fontSize:13, color:"var(--text-muted)" }}>Rapports de Performance</p>
          </div>

          {/* Error */}
          {error && (
            <div className="toast toast-err mb-16" style={{ borderRadius:"var(--r-sm)" }}>
              <span>⚠ {error}</span>
              <button onClick={clearError} style={{ background:"none", border:"none", cursor:"pointer", color:"var(--red)", fontSize:16, marginLeft:"auto" }}>✕</button>
            </div>
          )}

          {/* Microsoft */}
          <button
            onClick={loginMicrosoft}
            disabled={isAuthenticating}
            style={{ width:"100%", padding:"12px 16px", background:"#fff", border:"1.5px solid var(--border)", borderRadius:6, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:10, fontSize:13, opacity:isAuthenticating?0.6:1, transition:"background 0.15s" }}
            onMouseEnter={e=>{(e.currentTarget as HTMLButtonElement).style.background="#f5f5f5";}}
            onMouseLeave={e=>{(e.currentTarget as HTMLButtonElement).style.background="#fff";}}>
            <MicrosoftLogo/>
            <span style={{ color:"var(--black)", fontWeight:500 }}>Se connecter</span>
          </button>

        </div>
      </div>
    </div>
  );
}
